import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { config } from '../../config';
import { deletePreviousBooking } from '../redux/booking/previousBooking/actions';
import { CLEAR_ALL_API_ERRORS } from '../redux/requests/apiReducerFactory';
import { initializeChannelAndRegionIfNeeded } from '../redux/search/form/actions';

// This isn't a hook because it needs access to location which comes from Router
export const OnRouteChange = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const previousPathname = useRef(null);

  useEffect(() => {
    dispatch({
      type: CLEAR_ALL_API_ERRORS,
    });
  }, [dispatch, pathname]);

  useEffect(() => {
    if (pathname === '/') {
      dispatch(initializeChannelAndRegionIfNeeded());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  // This is used to delete an active booking when leaving the my-booking page
  useEffect(() => {
    if (pathname !== previousPathname.current) {
      if (previousPathname.current === '/my-booking') {
        deletePreviousBooking(dispatch);
      }
      previousPathname.current = pathname;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    let timeoutId = undefined;

    const AWINExclusionList = ['/booking/payment', '/booking/confirmation']; // Add to this if AWIN is not to fire.

    if (config['awin.enable']) {
      timeoutId = setTimeout(() => {
        if (!window.AWIN) {
          return;
        }

        if (!AWINExclusionList.includes(pathname)) {
          window.AWIN.Tracking.run();
        }
      }, 100);
    }

    // This clears the interval when the route changes, otherwise they stack up and cause a memory leak
    return () => clearInterval(timeoutId);
  }, [pathname]);

  return null;
};
